import posthog from 'posthog-js';

export default function usePostHog() {
  posthog.init(process.env.VUE_APP_POSTHOG_TOKEN, {
    api_host: 'https://eu.i.posthog.com',
    defaults: '2025-05-24',
  });

  return { posthog };
}
